module.exports = __webpack_public_path__ + "img/kefu2.3fd4801a.png";